<table>
  <tr>
    <th>Abbreviations</th>
    <th>Full Form of Abbreviations</th>
  </tr>
  <tr *ngFor="let abbreviation of abbreviations" matTooltip="{{abbreviation.elaboration}}">
    <td>{{abbreviation.shortName}}</td>
    <td>{{abbreviation.fullName}}</td>
  </tr>
</table>
